module.exports = __webpack_public_path__ + "static/media/crew-m-6.de1cfa2b.png";